import { useEffect, useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  BsFacebook,
  BsInstagram,
  BsGithub,
  BsTwitter,
  BsLinkedin,
  BsYoutube,
} from "react-icons/bs";

import "./Footer.scss";

const master = "../../asessts/images/master.png";
const visa = "../../asessts/images/visa.png";
const paypal = "../../asessts/images/paypal.png";
const stripeImage = "../../asessts/images/stripe.png";

const OFFICES = [
  {
    id: "uk",
    name: "United Kingdom",
    tz: "Europe/London",
    days: [1, 2, 3, 4, 5],
    open: 9,
    close: 18,
    address: "93 Bennetts Castle Lane, Dagenham, England, RM8 3YB",
    phones: ["+44 7354 473871"],
  },
  {
    id: "pk",
    name: "Pakistan",
    tz: "Asia/Karachi",
    days: [1, 2, 3, 4, 5, 6],
    open: 10,
    close: 19,
    address:
      "Office #1, G-Floor, Building #43, Street #9, Shama Road, Ichhra, Lahore, Punjab 54600",
    phones: ["042-37583100", "0323-4022301"],
  },
];

const SERVICES = [
  {
    title: "Build",
    items: [
      ["Shopify Development", "/shopify-development-services"],
      ["Enterprise Software", "/services/enterprise-software"],
      [".NET Development", "/.Net-development-services"],
      ["Unity Development", "/unity-game-development-company"],
      ["WordPress Development", "/wordpress-development-services"],
      ["Website Development", "/website-development"],
      ["Mobile App Development", "/mobile-development"],
      ["SaaS Application Development", "/sass-webpage"],
    ],
  },
  {
    title: "Grow",
    items: [
      ["SEO", "/affordable-seo-services-uk"],
      ["E-mail Marketing Software", "/services/email-marketing-software"],
      ["Sales Email Templates", "/services/sales-email-templates"],
      ["Marketing Analytics", "/services/marketing-analytics"],
      ["AI Website Generator", "/services/ai-website-generator"],
      ["Domain Registration", "/domain-registration"],
      ["WordPress Hosting", "/wordpress-hosting"],
    ],
  },
  {
    title: "Run and scale",
    items: [
      ["DevOps Services", "/services/devops"],
      ["Custom Software Development", "/custom-software-development-services"],
      ["Software QA Testing", "/services/software-qa-testing"],
      ["POC and IoT Development", "/services/poc-iot-development"],
      ["Offshore Development", "/services/offshore-software-development"],
      ["Hire A Software Developer", "/services/hire-software-developer"],
    ],
  },
];

const COMPANY = [
  ["About us", "/about-us"],
  ["Portfolio", "/portfolio"],
  ["Products", "/products"],
  ["Blog", "https://wellcreator.com/blog"],
  ["Timeline", "/timeline"],
  ["FAQs", "/faqs"],
  ["Sitemap", "/sitemap"],
];

const LEGAL = [
  ["Privacy Policy", "/privacy-policy"],
  ["Terms & Conditions", "/terms-conditions"],
  ["Refund Policy", "/refund-policy"],
  ["Career", "/career"],
];

const TOPICS = ["Product news", "Offers", "Developer tips"];

const PAYMENTS = [
  { name: "Visa", image: visa },
  { name: "Mastercard", image: master },
  { name: "PayPal", image: paypal },
  { name: "Stripe", image: stripeImage },
];

const SOCIALS = [
  {
    name: "Facebook",
    url: "https://www.facebook.com/wellcreator",
    icon: BsFacebook,
    color: "#1877f2",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/wellcreator/",
    icon: BsInstagram,
    color: "#e4405f",
  },
  {
    name: "Twitter",
    url: "https://twitter.com/wellcreator",
    icon: BsTwitter,
    color: "#1da1f2",
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/wellcreator/",
    icon: BsLinkedin,
    color: "#0a66c2",
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/channel/UCMYAfqVrzCDHOvlHJ1paIsw",
    icon: BsYoutube,
    color: "#ff0033",
  },
  {
    name: "GitHub",
    url: "https://github.com/wellcreator",
    icon: BsGithub,
    color: "#ffffff",
  },
];

function localInfo(office, now) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: office.tz,
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(now);

  const get = (type) => parts.find((part) => part.type === type)?.value;

  const day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(
    get("weekday"),
  );

  const hour = Number(get("hour")) + Number(get("minute")) / 60;

  return {
    time: `${get("hour")}:${get("minute")}`,
    weekday: get("weekday"),
    isOpen:
      office.days.includes(day) &&
      hour >= office.open &&
      hour < office.close,
  };
}

function Offices() {
  const [now, setNow] = useState(() => new Date());
  const [active, setActive] = useState(OFFICES[0].id);

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(timer);
  }, []);

  const office = OFFICES.find((item) => item.id === active);
  const { time, weekday, isOpen } = localInfo(office, now);

  return (
    <div className="wp-office">
      <div className="wp-tabs" aria-label="Office locations">
        {OFFICES.map((item) => (
          <button
            key={item.id}
            type="button"
            aria-pressed={item.id === active}
            className={item.id === active ? "on" : ""}
            onClick={() => setActive(item.id)}
          >
            {item.name}
          </button>
        ))}
      </div>

      <div className="wp-status" role="status">
        <span
          className={`wp-dot ${isOpen ? "open" : ""}`}
          aria-hidden="true"
        />
        {isOpen ? "Open now" : "Closed"} · {time} · {weekday}
      </div>

      <p className="wp-addr">{office.address}</p>

      <div className="wp-map">
        <iframe
          title={`${office.name} office location`}
          src={`https://maps.google.com/maps?q=${encodeURIComponent(
            office.address,
          )}&output=embed`}
          width="100%"
          height="220"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      <p className="wp-hours">
        Email:{" "}
        <a
          className="wp-email-link"
          href="mailto:info@wellcreator.com"
        >
          info@wellcreator.com
        </a>
      </p>

      <div className="wp-office-contact">
        <span className="wp-contact-label">Contact #</span>

        <div className="wp-phone-numbers">
          {office.phones.map((phone) => (
            <a
              className="wp-phone-link"
              key={phone}
              href={`tel:${phone.replace(/[^+\d]/g, "")}`}
            >
              {phone}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

function Newsletter({ onSubscribe }) {
  const [email, setEmail] = useState("");
  const [topics, setTopics] = useState(["Product news"]);
  const [state, setState] = useState({ s: "idle", m: "" });

  const toggle = (topic) => {
    setTopics((previous) =>
      previous.includes(topic)
        ? previous.filter((item) => item !== topic)
        : [...previous, topic],
    );
  };

  const submit = async (event) => {
    event.preventDefault();

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim())) {
      setState({
        s: "error",
        m: "Enter a valid email, like you@company.com.",
      });
      return;
    }

    if (!topics.length) {
      setState({
        s: "error",
        m: "Pick at least one topic.",
      });
      return;
    }

    setState({ s: "loading", m: "" });

    try {
      if (onSubscribe) {
        await onSubscribe(email.trim(), topics);
      } else {
        await new Promise((resolve) => setTimeout(resolve, 700));
      }

      setState({
        s: "success",
        m: "You’re in. Check your inbox to confirm.",
      });
      setEmail("");
    } catch {
      setState({
        s: "error",
        m: "Could not subscribe. Please try again.",
      });
    }
  };

  return (
    <form className="wp-news" onSubmit={submit} noValidate>
      <h3>Stay in the loop</h3>

      <p className="wp-news-copy">
        Level up your game with the latest insights, exclusive offers, and
        updates from Wellcreator—delivered straight to your inbox.
      </p>

      <fieldset className="wp-chips">
        <legend className="wp-sr">Topics</legend>

        {TOPICS.map((topic) => (
          <label
            key={topic}
            className={topics.includes(topic) ? "on" : ""}
          >
            <input
              type="checkbox"
              checked={topics.includes(topic)}
              onChange={() => toggle(topic)}
            />
            {topic}
          </label>
        ))}
      </fieldset>

      <div className={`wp-field ${state.s === "error" ? "bad" : ""}`}>
        <input
          type="email"
          value={email}
          placeholder="you@company.com"
          aria-label="Email address"
          autoComplete="email"
          aria-invalid={state.s === "error"}
          onChange={(event) => {
            setEmail(event.target.value);

            if (state.s !== "idle") {
              setState({ s: "idle", m: "" });
            }
          }}
        />

        <button
          type="submit"
          className="wp-btn"
          disabled={state.s === "loading"}
        >
          {state.s === "loading" ? "Sending…" : "Subscribe"}
        </button>
      </div>

      <p className={`wp-msg ${state.s}`} role="status" aria-live="polite">
        {state.m}
      </p>
    </form>
  );
}

function Services() {
  const [isMobile, setIsMobile] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia("(max-width: 640px)").matches,
  );

  const [query, setQuery] = useState("");

  const [open, setOpen] = useState({
    Build: false,
    Grow: false,
    "Run and scale": false,
    Company: false,
  });

  useEffect(() => {
    const media = window.matchMedia("(max-width: 640px)");
    const updateMobile = () => setIsMobile(media.matches);

    updateMobile();
    media.addEventListener("change", updateMobile);

    return () => media.removeEventListener("change", updateMobile);
  }, []);

  const term = query.trim().toLowerCase();

  const groups = useMemo(() => {
    return [...SERVICES, { title: "Company", items: COMPANY }]
      .map((group) => ({
        ...group,
        items: term
          ? group.items.filter(([name]) =>
              name.toLowerCase().includes(term),
            )
          : group.items,
      }))
      .filter((group) => group.items.length > 0);
  }, [term]);

  const handleSearch = () => {
    document.querySelector(".wp-groups")?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  };

  return (
    <nav className="wp-services" aria-label="Services and company links">
      <div className="wp-search-box">
        <input
          className="wp-search"
          type="search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              handleSearch();
            }
          }}
          placeholder="Find a service"
          aria-label="Find a service or company link"
        />

        <button
          type="button"
          className="wp-search-btn"
          onClick={handleSearch}
        >
          Search
        </button>
      </div>

      <div className="wp-groups">
        {groups.length === 0 && (
          <p className="wp-empty">No matches for "{query}".</p>
        )}

        {groups.map((group) => {
          const isOpen = !isMobile || !!term || !!open[group.title];
          const panelId = `wp-links-${group.title
            .toLowerCase()
            .replace(/\s+/g, "-")}`;

          return (
            <div
              key={group.title}
              className={`wp-group ${isOpen ? "is-open" : ""}`}
            >
              <button
                type="button"
                className="wp-gha"
                aria-expanded={isOpen}
                aria-controls={panelId}
                disabled={!isMobile || !!term}
                onClick={() =>
                  setOpen((previous) => ({
                    ...previous,
                    [group.title]: !previous[group.title],
                  }))
                }
              >
                <h3>{group.title}</h3>
                <span aria-hidden="true">+</span>
              </button>

              <ul className="wp-list" id={panelId} hidden={!isOpen}>
                {group.items.map(([name, href]) => (
                  <li key={name}>
                    {href.startsWith("https://") ? (
                      <a href={href}>{name}</a>
                    ) : (
                      <NavLink to={href} end>
                        {name}
                      </NavLink>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </nav>
  );
}

export default function FooterPro({ onSubscribe }) {
  return (
    <footer className="wp">
      <div className="wp-wrap wp-main">
        <div className="wp-col-a">
          <Offices />
        </div>

        <Services />

        <section
          className="wp-payments-column"
          aria-labelledby="wp-payments-title"
        >
          <h3 id="wp-payments-title">Payments</h3>

          <ul
            className="wp-inline wp-pay"
            aria-label="Accepted payment methods"
          >
            {PAYMENTS.map((payment) => (
              <li key={payment.name} className="wp-pay-item">
                <img
                  src={payment.image}
                  alt={payment.name}
                  title={payment.name}
                  loading="lazy"
                  className="wp-pay-logo"
                />
              </li>
            ))}
          </ul>

          <div className="wp-office-contact1">
            <span className="wp-office-note">
              Need a service? You can request it online anytime — we’re
              always ready to help.
            </span>
          </div>
        </section>

        <aside className="wp-newsletter-column">
          <Newsletter onSubscribe={onSubscribe} />
        </aside>
      </div>

      <div className="wp-bar">
        <div className="wp-wrap wp-bar-in">
          <span className="wp-copyright">
            © Wellcreator 2012 - 2026. All Rights Reserved.
          </span>

          <ul className="wp-inline wp-legal">
            {LEGAL.map(([name, href]) => (
              <li key={name}>
                <NavLink to={href} end>
                  {name}
                </NavLink>
              </li>
            ))}
          </ul>

          <ul className="wp-inline wp-social" aria-label="Follow WellCreator">
            {SOCIALS.map((social) => {
              const Icon = social.icon;

              return (
                <li key={social.name}>
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.name}
                    title={social.name}
                    className="wp-social-link"
                    style={{ "--social-color": social.color }}
                  >
                    <Icon
                      className="wp-social-logo"
                      aria-hidden="true"
                    />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </footer>
  );
}